module.exports = __webpack_public_path__ + "img/interface OneB Url-editor_5 prew.7af96431.jpg";